import {useInfiniteQuery} from '@tanstack/react-query';

import {fetchNewsList} from 'api/news';

const PAGE_SIZE = 12;

export function useInfiniteNewsList() {
    const query = useInfiniteQuery({
        queryKey: ['news-list'],
        queryFn: ({ pageParam = 1 }) =>
            fetchNewsList({
                page: pageParam,
                limit: PAGE_SIZE
            }),
        getNextPageParam: (lastPage) => (lastPage && lastPage.hasNextPage ? lastPage.nextPage : undefined)
    });

    const news = [];

    if (query.data && Array.isArray(query.data.pages)) {
        query.data.pages.forEach((page) => {
            if (page && Array.isArray(page.items)) {
                news.push(...page.items);
            }
        });
    }

    return {
        news,
        error: query.error,
        isLoading: query.isLoading,
        isFetchingNextPage: query.isFetchingNextPage,
        hasNextPage: query.hasNextPage,
        fetchNextPage: query.fetchNextPage
    };
}
